<template>
  <div class="serviceSelection">
    <v-btn
      v-if="services.length === 1"
      text
      :href="services[0].svc_frontend_url"
    >
      Go to {{ services[0].svc_name }}
    </v-btn>

    <v-menu
      v-else-if="services.length > 1"
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="white"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-apps</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(service, key) in services"
          :key="key"
          :href="service.svc_frontend_url"
        >
          <v-list-item-title>{{ service.svc_name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ServiceSelection',

  computed: {
    ...mapState({
      services: (state) => {
        const services = state.account.user.services.filter(
          (el) => el.svc_frontend_url && el.service_id !== process.env.VUE_APP_SERVICE,
        );

        if (state.account.user.is_staff && process.env.VUE_APP_SERVICE !== 'mam') {
          services.unshift({
            svc_name: 'MAM Dashboard',
            service_id: 'mam',
            svc_frontend_url: process.env.VUE_APP_MAM_CLIENT,
          });
        }
        return services;
      },
    }),
  },
};
</script>
